import './jquery-global.js';
import fancybox from '@fancyapps/fancybox';

require('classlist-polyfill');
require('array-polyfill.js');
require('bootstrap.native');
require('./lib/polyfill/matchMedia');
require('./lib/cartProductRemove');
require('./lib/categoryProductVariant');
require('./lib/menu');
require('./lib/dropdowns');
require('./lib/productLightbox');
require('./lib/productZoom');
require('./lib/search');
require('./lib/table/tableMobileEqualizer');
require('./lib/table/tableCollapser');
require('./lib/formFiller');
require('./lib/modal/infoModal');
require('./lib/modal/loginModal');
require('./lib/modal/recommendModal');
require('./lib/toggleContainer');
require('./lib/priceRangeSlider');
require('./lib/partners');
require('./lib/productRemember');
require('./lib/accountWishlist');
require('./lib/compare');
require('./lib/compare/swiper');
require('./lib/compare/main');
